module.exports = __webpack_public_path__ + "img/logo.21112c40.svg";